export default {
  namespaced: true,
  state: {
    all: [],
    isPersistent: false,
  },
  getters: {
    field: (state, getters) => (name) => {
      return getters.form.find(m => m.meta === name) || {};
    },
    general: (state, getters) => {
      return getters.unique(state.all.filter(m => m.status !== 422));
    },
    form: (state, getters) => {
      return getters.unique(state.all.filter(m => m.status === 422));
    },
    unique: () => (set) => {
      const keys = ['details', 'type'];

      return set.filter(
        (s => o => (k => !s.has(k) && s.add(k))(keys.map(k => o[k])
          .join('|')))(new Set()),
      );
    },
  },
  mutations: {
    add(state, message) {
      state.all.push({
        status: message.status,
        details: message.details,
        type: message.type,
      });
    },
    addFromApi(state, error) {
      if (error.response !== undefined
        && Array.isArray(error.response.data.errors)) {
        error.response.data.errors.forEach((e) => {
          state.all.push({
            status: e.status,
            details: e.details,
            meta: e.meta,
            type: 'is-danger',
          });
        });
      }
    },
    persist(state) {
      state.isPersistent = true;
    },
    reset(state) {
      state.all = state.isPersistent ? state.all : [];
      state.isPersistent = false;
    },
  },
};
